import Class from './c-content-chart-actual';
import './c-content-chart-actual@.vue';

export default Class;